import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin, BlockAM } from "../../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import { Table, Select, Col, Row, Pagination, Tooltip, Input, Radio, Checkbox, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import filterIcon from '../../../assets/images/icons/filter.svg';
import HoverCloseIcon from '../../../assets/images/icons/hover_close.svg';
import tagRomoveIcon from '../../../assets/images/icons/tag_close_icon.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom'
import FullLoader from "../../../assets/images/full-page-loader.gif"
import prevIcon from '../../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../../assets/images/icons/chevron-right.svg';
import { jwtDecode } from "jwt-decode";
import SiteCreateFreewheel from "./SiteCreateFreewheel";
import ZoneCreateFreewheel from "./Zone/ZoneCreateFreewheel";
import SiteViewEditFreewheel from "./SiteViewEditFreewheel";
import addIcon from '../../../assets/images/icons/add.svg';
import noData from '../../../assets/images/data-graph/no-data.svg';
import TableLoader from "../../TableLoader";
import errorData from '../../../assets/images/data-graph/error-data.svg';
import wifiPlusIcon from '../../../assets/images/icons/wifiplus.svg';
import ZoneViewEditFreewheel from "./Zone/ZoneViewEditFreewheel";
import RemoteFeedCreate from "../RemoteFeed/RemoteFeedCreate";
import RemoteFeedViewEdit from "../RemoteFeed/RemoteFeedViewEdit";

const { Option } = Select;

const SiteListingFreewheel = () => {


    const loadingContext = useContext(LoadingContext);

    const [tab, setTab] = useState("sites")
    const [apiCall, setApicall] = useState(false)

    const [pageView, setPageView] = useState("table")

    const [siteViewId, setSiteViewId] = useState("")
    const [siteViewName, setSiteViewName] = useState("")

    const [zoneViewId, setZoneViewId] = useState("")
    const [zoneViewName, setZoneViewName] = useState("")

    const [remoteFeedViewId, setRemoteFeedViewId] = useState("")
    const [remoteFeedViewObjectId, setRemoteFeedViewObjectId] = useState("")
    const [remoteFeedViewName, setRemoteFeedViewName] = useState("")

    const [checkRole, setCheckRole] = useState("admin")



    // const [colvis, setColvis] = useState({
    //     "z_cate": true,
    //     "invent_type": true,
    //     "p_name": true,
    //     "createdAt": true
    // })

    useEffect(() => {
        axios
            .get(configData.SERVER_URL + "remotefeed/siteListing", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setFilterSites(response.data.data);
            })
            .catch((error) => { });

    }, [])


    const columnsSite = [
        {
            title: 'Action',
            dataIndex: 'action',
            fixed: 'left',
            width: 70,
            render: (text, record) => {
                return (
                    <div className='btn_group'
                    >
                        <Tooltip title="Add Zone">
                            <button className='download_icon download_icon_d2'
                                onClick={() => { setSiteViewId(record.siteId); setSiteViewName(record.name); setPageView("createZone") }}>
                                <img src={wifiPlusIcon} alt='USP' />
                            </button>
                        </Tooltip>

                    </div >
                )
            },

        },

        {
            title: 'Site ID',
            dataIndex: 'siteId',
            key: 'siteId',
            fixed: 'left',
            width: 150,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data) => <div className='text_dark'>{data}</div>,
        },

        {
            title: 'Site Name',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
            width: 300,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data, record) => <div className='anchor_text_link_d2'
                onClick={() => {

                    setPageView("viewSite");
                    setSiteViewId(record.siteId)
                    setSiteViewName(record.name)

                }}
            >{data}</div>,
            // width: 200,

        },
        {
            title: 'Zones',
            dataIndex: 'z_count',
            key: 'z_count',
            width: 250,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data, record) => <div className='text_dark'>
                {data === 0 ?
                    <Link className="zero_value_design2" style={{ textDecoration: "none", cursor: "default" }} >{data}</Link> :
                    <Link className='text_primary back_area_increase_d2' onClick={() => { handleTabChange("zones", record.siteId) }}>{data}</Link>
                }

            </div>,
        },
        {
            title: 'Inventory Type',
            dataIndex: 'site_type',
            key: 'site_type',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data) => <div className="text_dark"> {data} </div>,
            // render: (data) => <div className="table_badges--d2 --violet"> {data} </div>,
            // width: 200,

        },
        {
            title: 'Category',
            dataIndex: 'categoryName',
            key: 'categoryName',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data) => <div className="text_dark"> {data} </div>,
            // width: 200,

        },

        {
            title: 'Floor Price',
            dataIndex: 'f_amount',
            key: 'f_amount',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data) => <div className='text_dark'>
                {data === "" ? <>-</> : <>  $ {data}</>}

            </div>,
            // width: 100,
        },

        // {
        //     title: "Created At",
        //     dataIndex: "createdAt",
        //     width: 120,
        //     key: "createdAt",
        //     sortDirections: ['ascend', 'descend', 'ascend'],
        //     sorter: true,
        //     render: (data) => <div className='text_dark'>{data}</div>,
        //     hidden: !colvis["createdAt"]
        // },


    ];




    const columnsZone = [
        {
            title: 'Zone ID',
            dataIndex: 'zoneId',
            key: 'zoneId',
            fixed: 'left',
            width: 100,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data) => <div className='text_dark'>{data}</div>,
        },
        {
            title: 'Zone Name',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
            // width: 200,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data, record) => <div className='anchor_text_link_d2'
                onClick={() => {

                    setPageView("viewZone");
                    setZoneViewId(record.zoneId)
                    setZoneViewName(record.name)
                    setSiteViewId(record.siteId)
                    setSiteViewName(record.siteName)

                }}
            >{data}</div>,

        },
        {
            title: 'Remote Feed',
            dataIndex: 'remotefeed',
            key: 'remotefeed',

            width: 450,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) => {
                // record.rfId = "";
                return (

                    <>
                        {(record.rfId === "" || record.rfId === undefined || record.rfId === null) ?
                            <div className='w_100 position-relative'>
                                <button className="remote_plus_btn_d2" onClick={() => {
                                    setZoneViewId(record.zoneId)
                                    setZoneViewName(record.name)
                                    setSiteViewId(record.siteId)
                                    setSiteViewName(record.siteName)
                                    setPageView("createRemoteFeed")
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M8 3.33334V12.6667" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M3.3335 8H12.6668" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </div>
                            :
                            <div className='anchor_text_link_d2'
                                onClick={() => {
                                    setZoneViewId(record.zoneId)
                                    setZoneViewName(record.name)
                                    setSiteViewId(record.siteId)
                                    setSiteViewName(record.siteName)
                                    setRemoteFeedViewId(record.rfId)
                                    setRemoteFeedViewName(record.rfName)
                                    setRemoteFeedViewObjectId(record.rf_id)

                                    setPageView("viewRemoteFeed")
                                }}
                            >{record.rfId}-{record.rfName}</div>

                        }
                    </>

                )
            },
        },
        // {
        //     title: 'Remote Feed Edit',
        //     dataIndex: 'remotefeed',
        //     key: 'remotefeed',

        //     width: 100,
        //     sorter: true,
        //     sortDirections: ['ascend', 'descend', 'ascend'],
        //     render: (text, record) => {
        //         return (
        //             <div className='w_100 position-relative'>
        //                 <button className="remote_plus_btn_d2" onClick={() => {
        //                     setZoneViewId(record.zoneId)
        //                     setZoneViewName(record.name)
        //                     setSiteViewId(record.siteId)
        //                     setSiteViewName(record.siteName)
        //                     setRemoteFeedViewId("")
        //                     setRemoteFeedViewObjectId("")
        //                     setRemoteFeedViewName("")
        //                     setPageView("viewRemoteFeed")
        //                 }}>
        //                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        //                         <path d="M8 3.33334V12.6667" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
        //                         <path d="M3.3335 8H12.6668" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
        //                     </svg>
        //                 </button>
        //             </div>
        //         )
        //     },
        // },
        {
            title: 'Device',
            dataIndex: 'device',
            key: 'device.label',
            sorter: true,
            width: 150,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) => {
                return (
                    <>{
                        text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
                            <div className="text_dark"> {text.label} </div>
                    }
                    </>
                )
            },
            // width: 200,

        },
        {
            title: 'Integration Type',
            dataIndex: 'integrationType',
            key: 'integrationType',
            sorter: true,
            width: 150,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) => {
                return (
                    <>{
                        text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
                            <div className="text_dark"> {text} </div>
                    }
                    </>
                )
            },
            // width: 200,

        },

        {
            title: 'Site ID',
            dataIndex: 'siteId',
            key: 'siteId',
            width: 150,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data) => <div className='text_dark'>{data}</div>,
        },

        {
            title: 'Site Name',
            dataIndex: 'siteName',
            key: 'siteName',
            width: 250,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data) => <div className='text_dark'>{data}</div>,
        },

        {
            title: 'Auction Type',
            dataIndex: 'auction_type',
            key: 'auction_type',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) => {
                return (
                    <>{
                        text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
                            <div className="text_dark"> {text} </div>
                    }
                    </>
                )
            },
            width: 150,

        },
        {
            title: 'Floor Type',
            dataIndex: 'fp_type',
            key: 'fp_type',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) => {
                return (
                    <>{
                        text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
                            <div className="text_dark"> {text} </div>
                    }
                    </>
                )
            },

            width: 150,
        },
        {
            title: 'Size',
            dataIndex: 'size',
            key: 'size',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data) => <div className='text_dark'>{data}</div>,
            width: 100,

        },


    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)
    const [tabLoad, setTabLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });

    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")

    const [filterShow, setFilterShow] = useState(false)
    const [filterSites, setFilterSites] = useState([])

    const [filterApply, setFilterApply] = useState({
        site: [],

    });
    const [filterApplyApiCall, setFilterApplyApiCall] = useState({
        site: [],
    });

    const [searchValue, setSearchValue] = useState('');

    const handleSearch = (e) => {
        setSearchValue(e.target.value.toLowerCase());
    };

    const filteredOptions = filterSites.filter(option =>
        option.label.toLowerCase().includes(searchValue)
    );

    const getLabels = (values) => {
        return values.map(value => {
            const site = filterSites.find(site => site.value === value);
            return site ? site.label : value;
        }).join(", ");
    };

    const dropdownRef = useRef(null);
    const filterShowRef = useRef(filterShow);
    useEffect(() => {
        filterShowRef.current = filterShow;
    }, [filterShow]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                filterShowRef
            ) {
                const selectElement = document.getElementById('adcodeSelect');
                if (!selectElement?.closest('.ant-select')?.classList?.contains('ant-select-open')) {
                    let temp = JSON.parse(JSON.stringify(filterApplyApiCall));

                    setFilterApply(prevState => ({
                        ...prevState,
                        site: temp.site,

                    }));
                    setFilterShow(false);
                }
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });


    useEffect(() => {
        if (!initialLoad && tab === "zones") {
            let tempPage = page
            tempPage.current = 1
            setPage(tempPage);
            setApicall(!apiCall)
        }
    }, [filterApplyApiCall])

    function handleFilterApply(type, value) {
        let tempFilterApply = { ...filterApply }
        if (type === "site") {
            let newValue = [];
            if (tempFilterApply.site.includes(value)) {
                newValue = tempFilterApply.site.filter((item) => item !== value);
            } else {
                newValue = [...tempFilterApply.site, value];
            }
            tempFilterApply.site = newValue
        };
        setFilterApply(tempFilterApply)
    }





    const getData = () => {
        setLoading(true)

        if (tab === "zones") {
            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
                let token = Cookies.get("token_xapads_ssp");

                axios
                    .post(configData.SERVER_URL + `ops/freewheel/zoneList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`,
                        {
                            filter: filterApplyApiCall
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "x-access-token": token,
                            },
                        })
                    .then((response) => {
                        setData(response.data.data.data)
                        if (response.data.data.data.length > 0) {
                            let tempPage = { ...page }
                            tempPage.total = response.data.data.metaData?.totalRecords
                            setPage(tempPage)
                        }

                        setLoading(false)
                        setInitialLoad(false)
                        setTabLoad(false)
                    })
                    .catch((error) => {
                        setData([])
                        setLoading(false)
                        setInitialLoad(false)
                        setTabLoad(false)
                    });
            }
        }

        else {
            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
                let token = Cookies.get("token_xapads_ssp");
                axios
                    .get(configData.SERVER_URL + `ops/freewheel/siteList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`,
                        //      {
                        //     filter: []
                        // }, 
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "x-access-token": token,
                            },
                        })
                    .then((response) => {
                        setData(response.data.data.data)
                        if (response.data.data.data.length > 0) {
                            let tempPage = { ...page }
                            tempPage.total = response.data.data.metaData?.totalRecords
                            setPage(tempPage)
                        }

                        setLoading(false)
                        setInitialLoad(false)
                        setTabLoad(false)
                    })
                    .catch((error) => {
                        setData([])
                        setLoading(false)
                        setInitialLoad(false)
                        setTabLoad(false)
                    });
            }
        }
    }


    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        BlockAM()
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setCheckRole(checkRole)
        }
        getData()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])



    useEffect(() => {
        if (!initialLoad && !tabLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);

    const handleTabChange = (data, siteIdData) => {
        let tempPageSize = { ...page }
        tempPageSize.current = 1;
        setPage(tempPageSize)
        setSearch("")
        setSort({
            name: "",
            type: ""
        })

        setTabLoad(true)
        setData([])
        setTab(data)
        if (data === "sites") {
            setFilterApply({
                site: []
            })
            setFilterApplyApiCall({
                site: []
            })
        }
        if (data === "zones" && siteIdData !== "") {
            let tempFilterApply = { ...filterApply }
            tempFilterApply.site = [siteIdData]
            setFilterApply(tempFilterApply)
            setFilterApplyApiCall(tempFilterApply)
        }
        if (!(data === "zones" && siteIdData !== "")) {
            setApicall(!apiCall)
        }


    }

    const handleTabChangeBreadcrum = (data) => {
        let tempPageSize = { ...page }
        tempPageSize.current = 1;
        setPage(tempPageSize)
        setSearch("")
        setSort({
            name: "",
            type: ""
        })

        setTabLoad(true)
        setData([])
        setTab(data)
        if (data === "sites") {
            setFilterApply({
                site: []
            })
            setFilterApplyApiCall({
                site: []
            })

            setApicall(!apiCall)
        }

        // if (data === "zones" && siteIdData !== "") {
        //     let tempFilterApply = { ...filterApply }
        //     tempFilterApply.site = [siteIdData]
        //     setFilterApply(tempFilterApply)
        //     setFilterApplyApiCall(tempFilterApply)
        // }
        // if (!(data === "zones" && siteIdData !== "")) {
        //     setApicall(!apiCall)
        // }
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };



    const handlePageViewEdit = (data, reload) => {
        if (reload === "yes") {
            setApicall(!apiCall)
            setTabLoad(true)

            axios
                .get(configData.SERVER_URL + "remotefeed/siteListing", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    setFilterSites(response.data.data);
                })
                .catch((error) => { });
        }
        setSiteViewId("")
        setSiteViewName("")

        setZoneViewId("")
        setZoneViewName("")

        setRemoteFeedViewId("")
        setRemoteFeedViewObjectId("")
        setRemoteFeedViewName("")

        setPageView(data)

    }

    const handlePageViewEditBreadcrum = (data, tabName) => {
        setSiteViewId("")
        setSiteViewName("")
        setZoneViewId("")
        setZoneViewName("")

        setRemoteFeedViewId("")
        setRemoteFeedViewObjectId("")
        setRemoteFeedViewName("")
        setPageView(data)
        handleTabChangeBreadcrum(tabName)
    }


    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :
                    (filterApplyApiCall.site.length > 0) && loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        (filterApplyApiCall.site.length > 0) && !loading ?
                            <div className='no_data_screen'>
                                <div className='text-center'>
                                    <img src={errorData} className='' alt="" />
                                    <div className='float_text_div'>

                                    </div>
                                </div>
                            </div>
                            :
                            loading ?
                                <div className='no_data_screen'>
                                    <div className='text-center'>

                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='no_data_screen' >
                                    <div className='text-center'>
                                        <img src={noData} className='' alt="" />
                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
            }
            </>

    };




    return (
        <>


            <div className="container_box--wrapper pt_header"
                style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600"> Freewheel </h1>
                </div>

                <div className="radio_btn_with_bars w-100 justify-content-between">
                    <div className="radios_btns --radios_btns_new">
                        <Radio.Group
                            className='radio_btn--group mb-0'
                            value={tab}
                            onChange={(event) => {
                                // console.log(event.target.value, tab)
                                // if (event.target.value !== tab) {
                                handleTabChange(event.target.value, "")

                                // }

                            }}
                        >
                            <Radio.Button value="sites">Sites</Radio.Button>
                            <Radio.Button value="zones">Zones</Radio.Button>
                        </Radio.Group>
                    </div>
                </div>

                <div className={data.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height_with_tabs"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between">
                                <div className="search_filter_create_new_d2 w-100">
                                    <div className="custom_filter_design_d2 --new_layout_design_btn">
                                        <div className="form_content_block--group">
                                            {!initialLoad && !tabLoad &&
                                                <Input
                                                    type='text'
                                                    className='form_control basic md search_input w_table_search'
                                                    placeholder="Search"
                                                    value={search}
                                                    onChange={(e) => {

                                                        if (e.target.value.trim().length === 0) {
                                                            setLoading(true)
                                                        }

                                                        setSearch(e.target.value)
                                                    }}
                                                />
                                            }
                                        </div>
                                        {tab === "zones" && !initialLoad && !tabLoad &&
                                            <div className="filter_tags_design_d2">
                                                <ul className="p-0 m-0">
                                                    {filterApplyApiCall.site.length > 0 &&
                                                        <li>
                                                            <div className="d-flex">
                                                                <span className="black_text_d2">Sites:</span>
                                                                {getLabels(filterApplyApiCall.site)?.split(',')?.length === 0 ?
                                                                    getLabels(filterApplyApiCall.site) :
                                                                    <>
                                                                        <>{getLabels(filterApplyApiCall.site)?.split(",")[0]} </>
                                                                        {getLabels(filterApplyApiCall.site)?.split(",")?.length > 1 && <>  , &nbsp;+{getLabels(filterApplyApiCall.site)?.split(",")?.length - 1} ... </>}
                                                                    </>}
                                                            </div>
                                                            <button type="button"><img src={tagRomoveIcon} className="" alt=""
                                                                onClick={() => {
                                                                    let tempFilterApply = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                                    let tempFilterApply2 = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                                    tempFilterApply.site = []
                                                                    tempFilterApply2.site = []
                                                                    setFilterApply(tempFilterApply2)
                                                                    setFilterApplyApiCall(tempFilterApply)
                                                                }}
                                                            /> </button>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        {tab === "zones" && !initialLoad && !tabLoad &&
                                            <Dropdown ref={dropdownRef}
                                                show={filterShow} onToggle={() => { setFilterShow(!filterShow) }} className="" autoClose={false}>

                                                <div className="position-relative hover_effec_hide_show_d2">
                                                    <Dropdown.Toggle id="dropdown-autoclose-false">
                                                        <Button className="" icon={
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                <path d="M12.5611 2H1.44995L5.8944 7.25556V10.8889L8.11662 12V7.25556L12.5611 2Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        }>
                                                            Filter
                                                            {filterApplyApiCall?.site?.length > 0 &&
                                                                <span className="selected_filter_tag_d2">
                                                                    <div>{filterApplyApiCall?.site?.length}</div>
                                                                </span>
                                                            }
                                                        </Button>
                                                    </Dropdown.Toggle>
                                                    {filterApplyApiCall?.site?.length > 0 &&
                                                        <div className="clear_filter_icon_d2" style={{ right: '1.7rem', top: '0.8rem' }}>
                                                            <button type="button"> <img src={HoverCloseIcon} alt=""
                                                                onClick={() => {
                                                                    setFilterApply({
                                                                        site: []
                                                                    })
                                                                    setFilterApplyApiCall({
                                                                        site: []
                                                                    })
                                                                    setFilterShow(false)
                                                                }}
                                                            /> </button>
                                                        </div>
                                                    }
                                                </div>
                                                <Dropdown.Menu>
                                                    <div className="filter_inner_heading_d2">

                                                        <p className="m-0">Sites</p>
                                                        <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">

                                                            <Select
                                                                id="adcodeSelect"
                                                                // {...sharedProps}
                                                                // value={selectedPublishers}
                                                                value={filterApply.site}
                                                                popupClassName='diff_select_d2'
                                                                // onChange={setValue}
                                                                showSearch={false}
                                                                placeholder='- Select -'
                                                                className="form_select basic error"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >

                                                                {filteredOptions.map(option => (
                                                                    <Select.Option key={option.value} value={option.value}>
                                                                        <div
                                                                            // onMouseDown={(e) => e.preventDefault()}
                                                                            // onClick={() => handleSelectPublisher(option.value)}
                                                                            onClick={() => handleFilterApply("site", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                // checked={selectedPublishers.includes(option.value)}
                                                                                checked={filterApply.site.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <hr />
                                                    </div>
                                                    <div className="filter_bottom_btns_d2 text-end">
                                                        <button className="reset" type='button'
                                                            onClick={() => {
                                                                setFilterApply({
                                                                    site: []
                                                                })
                                                                setFilterApplyApiCall({
                                                                    site: []
                                                                })
                                                                setFilterShow(false)
                                                            }}

                                                        >Reset</button>
                                                        <button className="apply" type='button'
                                                            onClick={() => {
                                                                let tempdata = JSON.parse(JSON.stringify(filterApply));
                                                                setFilterApplyApiCall(tempdata)
                                                                setFilterShow(false)
                                                            }}
                                                        >Apply</button>
                                                    </div>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        }
                                    </div>

                                    <div className="btn_group">
                                        {!initialLoad && !tabLoad &&
                                            <>
                                                {tab === "sites" ?
                                                    <button className='btn btn_primary w_fit_content md'
                                                        onClick={() => { setPageView("createSite") }}
                                                    ><span><img src={addIcon} alt='USP' /> New Site</span></button>
                                                    :
                                                    <button className='btn btn_primary w_fit_content md'
                                                        onClick={() => { setPageView("createZone") }}
                                                    ><span><img src={addIcon} alt='USP' /> New Zone</span></button>
                                                }
                                            </>
                                        }
                                    </div>
                                    {/* <div className="custom_filter_design_d2"> 
                                    <div className="column_hide_unhide_d2">
                                        <Dropdown className="" autoClose="outside">
                                            <Dropdown.Toggle id="dropdown-autoclose-outside">
                                                <img src={columnIcon} alt="" />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <div className="colunm_checkbox">
                                                    <ul className="p-0 m-0">

                                                        <li>
                                                            <label htmlFor="oneone">
                                                                <input className="form-check-input" type="checkbox" id="oneone"
                                                                    checked={colvis.z_cate}
                                                                    onChange={() => {
                                                                        let tempData = { ...colvis }
                                                                        tempData.z_cate = !tempData.z_cate
                                                                        setColvis(tempData)
                                                                    }}
                                                                /> <span>Category</span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label htmlFor="twotwo">
                                                                <input className="form-check-input" type="checkbox" id="twotwo"
                                                                    checked={colvis.invent_type}
                                                                    onChange={() => {
                                                                        let tempData = { ...colvis }
                                                                        tempData.invent_type = !tempData.invent_type
                                                                        setColvis(tempData)
                                                                    }}
                                                                /> <span>Inventory Type</span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label htmlFor="three">
                                                                <input className="form-check-input" type="checkbox" id="three"
                                                                    checked={colvis.p_name}
                                                                    onChange={() => {
                                                                        let tempData = { ...colvis }
                                                                        tempData.p_name = !tempData.p_name
                                                                        setColvis(tempData)
                                                                    }}
                                                                /> <span>Publisher</span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label htmlFor="four">
                                                                <input className="form-check-input" type="checkbox" id="four"
                                                                    checked={colvis.createdAt}
                                                                    onChange={() => {
                                                                        let tempData = { ...colvis }
                                                                        tempData.createdAt = !tempData.createdAt
                                                                        setColvis(tempData)
                                                                    }}
                                                                /> <span>Created At</span>
                                                            </label>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>

                        <div className="table_content--box --new_layout_table_design table_empty_screen_d2">
                            {loading && !initialLoad && !tabLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad || tabLoad ?
                                <TableLoader />

                                :
                                <>
                                    {tab === "sites" ?

                                        <Table
                                            columns={columnsSite}
                                            pageSize={100}
                                            dataSource={data}
                                            onChange={handleTableChange}
                                            pagination={false}
                                            rowKey={(record) => record.id}
                                            locale={locale}
                                            scroll={{ x: 'max-content', y: 'calc(100vh - 36.3rem' }} />

                                        :
                                        <Table
                                            columns={columnsZone}
                                            pageSize={100}
                                            dataSource={data}
                                            onChange={handleTableChange}
                                            pagination={false}
                                            rowKey={(record) => record.id}
                                            locale={locale}
                                            // scroll={{ x: 1500, y: 'calc(100vh - 27rem' }} />
                                            scroll={{ x: 'max-content', y: 'calc(100vh - 36.3rem' }} />



                                    }
                                </>
                            }

                            {data.length > 0 &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}  // Pass individual props instead of spreading them
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>
            </div >

            {pageView === "createSite" &&
                <SiteCreateFreewheel
                    handlePageViewChange={handlePageViewEdit}

                />
            }

            {
                pageView === "createZone" &&
                <ZoneCreateFreewheel
                    handlePageViewChange={handlePageViewEdit}
                    handlePageViewEditBreadcrum={handlePageViewEditBreadcrum}
                    siteViewId={siteViewId}
                    siteViewName={siteViewName}
                />
            }


            {
                pageView === "viewSite" &&
                <SiteViewEditFreewheel
                    handlePageViewChange={handlePageViewEdit}
                    siteViewId={siteViewId}
                    siteViewName={siteViewName}
                />
            }


            {
                pageView === "viewZone" &&
                <ZoneViewEditFreewheel
                    handlePageViewChange={handlePageViewEdit}
                    handlePageViewEditBreadcrum={handlePageViewEditBreadcrum}
                    zoneViewId={zoneViewId}
                    zoneViewName={zoneViewName}
                    siteViewName={siteViewName}
                    siteViewId={siteViewId}
                />
            }

            {
                pageView === "createRemoteFeed" &&
                <RemoteFeedCreate
                    handlePageViewChange={handlePageViewEdit}
                    handlePageViewEditBreadcrum={handlePageViewEditBreadcrum}
                    siteViewId={siteViewId}
                    siteViewName={siteViewName}
                    zoneViewId={zoneViewId}
                    zoneViewName={zoneViewName}
                    typeRf="FreeWheel"
                />
            }

            {
                pageView === "viewRemoteFeed" &&
                <RemoteFeedViewEdit
                    handlePageViewChange={handlePageViewEdit}
                    handlePageViewEditBreadcrum={handlePageViewEditBreadcrum}
                    siteViewId={siteViewId}
                    siteViewName={siteViewName}
                    zoneViewId={zoneViewId}
                    zoneViewName={zoneViewName}
                    remoteFeedViewId={remoteFeedViewId}
                    remoteFeedViewObjectId={remoteFeedViewObjectId}
                    remoteFeedViewName={remoteFeedViewName}
                    typeRf="FreeWheel"
                />
            }
        </>
    );
};

export default SiteListingFreewheel;
